module.exports = __webpack_public_path__ + "img/selected0-min.3e13d9f4.png";